import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogService, FormConfigurationService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from '../../constants/api-endpoints.constants';
import { POP_UP_CODES, SAVE_RESULT_STATUS, SERVER_ERROR_POP_UP_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES, VERSIONS } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';

@Component({
  selector: 'app-iccms-request-processing-schedule',
  templateUrl: './iccms-request-processing-schedule.component.html',
  styleUrl: './iccms-request-processing-schedule.component.scss'
})
export class IccmsRequestProcessingScheduleComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.iccmsRequestProcessingSchedule;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';

  private isEditing = false;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private formConfigurationService: FormConfigurationService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.applicationFunctions = {
    };

    this.coreService.conditionFunctions = {
    }

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.id = id;
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getIccmsRequestProcessingScheduleConfigAndResponse;
        this.isEditing = true;
      }
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    this.exit();
  }

  dialogButton_saveSuccessful_Clicked(event: any): void {
    this.exit(true);
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.navigate([ROUTE_CONSTANTS.iccmsRequestProcessingSchedule.list], ignoreUnsavedChanges);
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.iccmsRequestProcessingSchedule.save, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            if (SERVER_ERROR_POP_UP_CODES.saveIccmsRequestProcessingSchedule.includes(data.message)) {
              this.activeDialog = data.message;
            }
            else {
              this.id = data.id;
              this.activeDialog = POP_UP_CODES.common.saveSuccessful;
            }
            this.dialogService.showDialog(this.activeDialog);
          }
        })
    );
  }
}
